/* eslint-disable no-use-before-define */
import './form.css'
import React from 'react'
import { FieldArray, Field } from 'formik'
import { Flyout, Fields, arrayFrom, subscribe, unsubscribe, isEquals, getConfig } from '../../twd'
const { Labels } = Fields
import SecuritiesField from './securities-field'
import SaveSearchButton from './save-search-button'
import SubmitButton from './submit-button'
import SymbolField from './symbol-field'
import { FormFieldArrays } from './form-field-arrays'
import { initialValues } from './from-search-params'
import toSearchParams from './to-search-params'

let getResetValues = (curr) => {

    let holdInvType = arrayFrom(curr.holdInvType)
    let a = toSearchParams(curr)
    delete a.holdInvType

    let defaultState = getConfig('account_states.0.stateOfResidence','')
    let defaultValues = Object.assign({}, initialValues, {
        holdInvType,
        muniStates: arrayFrom(defaultState).filter(Boolean).map(a => `holdState=${a}`),
        cdBlueSky: arrayFrom(defaultState).filter(Boolean).map(a => `holdBlueSkyStateCD=${a}`),
    })
    let b = toSearchParams(defaultValues)
    delete b.holdInvType

    if (!isEquals(a,b)) return defaultValues

    return Object.assign({}, initialValues, {
        holdInvType,
        corpMarketTypes: [],
        cdMarketTypes: [],
        cdBlueSky: [],
        muniStates: [],
        rating: "all-ratings",
        holdMoodyRatingMin: "ALL",
        holdMoodyRatingMax: "ALL",
        holdSpRatingMin: "ALL",
        holdSpRatingMax: "ALL",
        holdRatingAndOr: false,
    })
}


export default ({
    handleSubmit,
    values,
    errors,
    validateForm,
    resetForm,
    setFieldValue
}) => {

    React.useEffect(() => { validateForm() }, [])

    React.useEffect(() => {
        let subId = subscribe('search_saved.advanced_screener_form', ({savedQueryId}) => {
            setFieldValue('savedQueryId', savedQueryId, false)
            values.savedQueryId = savedQueryId
        })
        return () => {
            unsubscribe(subId)
        }
    }, [])

    React.useEffect(() => {
        let subId = subscribe('manage_saved_searches.advanced_screener_form', ({deletedIds}) => {
            var id = values.savedQueryId
            var isDeleted = arrayFrom(deletedIds).indexOf(id)>=0
            if (!isDeleted) return

            setFieldValue('savedQueryId', '', false)
            delete values.savedQueryId
        })
        return () => {
            unsubscribe(subId)
        }
    }, [])

    let hasDeMinimis = getConfig('entitlements.ShowDeMinimisSearchCriteriaInOfferSearch', 'No') === 'Yes'
    let invType = arrayFrom(values.holdInvType)[0]
    let isCorp = invType==='C'
    let isMuni = invType==='M'
    let isCD = invType==='S'
    let isTreasury = invType==='T'
    let isAgency = invType==='A'
    let hasRating = !(isCD || isTreasury)

    return (
    <form className="advanced-screener-search-form-form" onSubmit={handleSubmit}>
    <div className="row vertical-offset-lg">
        <div className="col-md-6 col-xs-6">
        <Flyout label="Security type" className="btn-label btn-flyout medium-header" html={Labels.Securities} />
        </div>
        <div className="col-md-6 col-xs-6 text-right">
        <button
            type="button"
            data-name="advanced-screener-clear-all-selections"
            className="link-button"
            onClick={() => {
                resetForm(getResetValues(values))
                setTimeout(() => { validateForm() })
            }}
        >Clear All Selections</button>
        </div>
        <div className="col-xs-12 col-md-12">
            <FieldArray name="holdInvType" component={SecuritiesField} />
        </div>
    </div>
    <div className="row form-group" style={{marginBottom:0}}>
        <div className="col-lg-6 col-md-6 col-xs-12">
            <Field
                data-name="advanced-screener-issue"
                name="issuer"
                component={Fields.Text}
                error={errors.issuer}
                label={(<Flyout label="Issuer" html={Labels.Issuer} />)}
            />
        </div>
        <div className="col-lg-6 col-md-6 col-xs-12">
            <Field
                data-name="advanced-screener-cusip"
                name="cusip"
                component={Fields.Text}
                error={errors.cusip}
                label={(<Flyout label="CUSIP" html={Labels.Cusip} />)}
            />
        </div>
    </div>

    { isCorp && (
        <div className="row vertical-offset-md-xxs vertical-offset-sm-sm vertical-offset-xs-sm">
        <div className="col-xs-12 col-md-12">
            <div className="row form-group" style={{marginBottom:'0px'}}>
                <div className="col-lg-3 col-md-3 col-xs-12">
                    <FieldArray
                        name="corpSectors"
                        render={(args) => <Fields.SelectMulti {...args}
                            dataName='advanced-screener-corp-sectors'
                            emptyText='All sectors'
                            showSelectAll={true}
                            options={FormFieldArrays.corpSectors} listConfig={{ style: { minWidth:'200px' } }}
                            label={(<Flyout label="Sectors" html={Labels.CorpSector} />)}
                        />}
                    />
                </div>
                <div className="col-lg-3 col-md-3 col-xs-12">
                    <FieldArray
                        name="corpFeatures"
                        render={(args) => <Fields.SelectMulti {...args}
                            dataName='advanced-screener-corp-type'
                            options={FormFieldArrays.corpFeatures}
                            label={(<Flyout label="Type" html={Labels.CorpFeatures} />)}
                        />}
                    />
                </div>
                <div className="col-lg-2 col-md-3 col-xs-12">
                    <FieldArray
                        name="corpDebtRanks"
                        render={(args) => <Fields.SelectMulti {...args}
                            dataName='advanced-screener-corp-debt-ranking'
                            showSelectAll={true}
                            options={FormFieldArrays.corpDebtRanks}
                            listConfig={{ style: { minWidth:'200px' } }}
                            label={(<Flyout label="Debt ranking" html={Labels.CorpDebtRanks} />)}
                        />}
                    />
                </div>
                <div className="col-lg-2 col-md-3 col-xs-12">
                    <FieldArray
                        name="corpMarketTypes"
                        render={(args) => <Fields.SelectMulti {...args}
                            dataName='advanced-screener-corp-market-type'
                            options={FormFieldArrays.corpMarketTypes}
                            listConfig={{ style: { minWidth:'130px' } }}
                            inputConfig={{ style: { paddingRight:'25px' } }}
                            label={(<Flyout label="Market type" html={Labels.CorpMarketTypes} />)}
                        />}
                    />
                </div>
                <div className="col-lg-2 col-md-3 col-xs-12">
                    <Field
                        name="holdSymbol"
                        component={SymbolField}
                        listConfig={{ style: { minWidth:'230px', minHeight:'0px' } }}
                        label={(<Flyout label="Symbol" html={Labels.CorpSymbol} />)}
                    />
                </div>
            </div>
        </div>
        </div>
    )}

    { isMuni && (
        <div className="row vertical-offset-md-xxs vertical-offset-sm-sm vertical-offset-xs-sm">
        <div className="col-xs-12 col-md-12">
            <div className="row form-group">
                <div className="col-lg-3 col-md-3 col-xs-12">
                    <FieldArray
                        name="muniStates"
                        render={(args) => <Fields.SelectMulti {...args}
                            dataName='advanced-screener-muni-states'
                            showSelectAll={true}
                            options={FormFieldArrays.muniStates}
                            label={(<Flyout label="State / Territory" html={Labels.MuniStates} />)}
                        />}
                    />
                </div>
                <div className="col-lg-3 col-md-3 col-xs-12">
                    <FieldArray
                        name="muniCategories"
                        render={(args) => <Fields.SelectMulti {...args}
                            dataName='advanced-screener-muni-categories'
                            options={FormFieldArrays.muniCategories}
                            listConfig={{ style: { minWidth:'210px' } }}
                            label={(<Flyout label="Category" html={Labels.MuniCategories} />)}
                        />}
                    />
                </div>
                <div className="col-lg-2 col-md-3 col-xs-12">
                    <FieldArray
                        name="muniTaxTreatments"
                        render={(args) => <Fields.SelectMulti {...args}
                            dataName='advanced-screener-muni-tax-treatment'
                            options={FormFieldArrays.muniTaxTreatments}
                            listConfig={{ style: { minWidth:'200px' } }}
                            label={(<Flyout label="Tax treatment" html={Labels.MuniTaxTreatments} />)}
                        />}
                    />
                </div>
                <div className="col-lg-2 col-md-3 col-xs-12">
                    <FieldArray
                        name="muniPurposes"
                        render={(args) => <Fields.SelectMulti {...args}
                            dataName='advanced-screener-muni-use-of-proceeds'
                            showSelectAll={true}
                            options={FormFieldArrays.muniPurposes}
                            listConfig={{ style: { minWidth:'150px' } }}
                            label={(<Flyout label="Use of proceeds" html={Labels.MuniPurposes} />)}
                        />}
                    />
                </div>
                <div className="col-lg-2 col-md-3 col-xs-12">
                    <FieldArray
                        name="muniEnvironmentals"
                        render={(args) => <Fields.SelectMulti {...args}
                            dataName='advanced-screener-muni-environmental'
                            options={FormFieldArrays.muniEnvironmentals}
                            listConfig={{ style: { minWidth:'300px' } }}
                            label={(<Flyout label="Environmental" html={Labels.MuniEnvironmentals} />)}
                        />}
                    />
                </div>
                { hasDeMinimis && <div className="col-lg-3 col-md-3 col-xs-12">
                    <FieldArray
                        name="muniDeminimis"
                        render={(args) => <Fields.SelectMulti {...args}
                            dataName='advanced-screener-muni-deminimis'
                            showSelectAll={true}
                            options={FormFieldArrays.muniDeminimis}
                            listConfig={{style: {minWidth: '250px'}}}
                            label={(<Flyout label="De Minimis" html={Labels.MuniDeminimis}/>)}
                        />}
                    />
                </div>}
                <div className={"col-lg-3 col-md-3 col-xs-12" + (hasDeMinimis ? ' advanced-screener-issuer-container' : '')}>
                    <Field
                        name="muniInsured"
                        component={Fields.Checkbox}
                        data-name='advanced-screener-muni-insured'
                        label="Insured"
                        info={Labels.MuniInsured}
                    />
                </div>
            </div>
        </div>
        </div>
    )}

    { isCD && (
        <div className="row vertical-offset-md-xxs vertical-offset-sm-sm vertical-offset-xs-sm">
        <div className="col-xs-12 col-md-12">
            <div className="row form-group">
                <div className="col-lg-3 col-md-4 col-xs-12">
                    <FieldArray
                        name="cdBlueSky"
                        render={(args) => <Fields.SelectMulti {...args}
                            dataName="advanced-screener-cd-bluesky"
                            showSelectAll={true}
                            options={FormFieldArrays.cdBlueSky} label={(<Flyout label="Blue Sky State / Territory" html={Labels.CdBlueSky} />)}
                        />}
                    />
                    <Flyout label="Blue Sky Restriction" html={Labels.BlueSkyRestriction} />
                </div>
                <div className="col-lg-3 col-md-3 col-xs-12">
                    <FieldArray
                        name="cdMarketTypes"
                        render={(args) => <Fields.SelectMulti {...args}
                            dataName="advanced-screener-cd-market-type"
                            options={FormFieldArrays.cdMarketTypes}
                            label={(<Flyout label="Market type" html={Labels.CorpMarketTypes} />)}
                        />}
                    />
                </div>
                <div className="col-lg-2 col-md-3 col-xs-12">
                    <Field
                        name="cdFdic"
                        component={Fields.Text}
                        data-name="advanced-screener-cd-fdic"
                        label={(<Flyout label="FDIC number" html={Labels.CdFdic} />)}
                    />
                </div>
            </div>
        </div>
        </div>
    )}

    { isAgency && (
        <div className="row vertical-offset-md-xxs vertical-offset-sm-sm vertical-offset-xs-sm">
        <div className="col-xs-12 col-md-12">
            <div className="row form-group">
                <div className="col-md-3 col-xs-12">
                    <FieldArray
                        name="agencyTypes"
                        render={(args) => <Fields.SelectMulti {...args}
                            dataName="advanced-screener-agency-issuer"
                            showSelectAll={true}
                            options={FormFieldArrays.agencyTypes}
                            listConfig={{ style: { minWidth:'365px' } }}
                            label={(<Flyout label="Agency/GSE" html={Labels.AgencyTypes} />)}
                        />}
                    />
                </div>
            </div>
        </div>
        </div>
    )}

    { isTreasury && (
        <div className="row vertical-offset-md-xxs vertical-offset-sm-sm vertical-offset-xs-sm">
        <div className="col-xs-12 col-md-12">
            <div className="row form-group">
                <div className="col-md-3 col-xs-12">
                    <FieldArray
                        name="treasuryTypes"
                        render={(args) => <Fields.SelectMulti {...args}
                            dataName="advanced-screener-treasury-type"
                            showSelectAll={true}
                            options={FormFieldArrays.treasuryTypes}
                            label={(<Flyout label="Type" html={Labels.TreasuryTypes} />)}
                        />}
                    />
                </div>
            </div>
        </div>
        </div>
    )}

    <hr aria-hidden="true" className="vertical-offset-xs"></hr>

    <div className="row vertical-offset-md-xxs vertical-offset-sm-sm vertical-offset-xs-sm">
    <div className="col-xs-12 col-md-6">
        <div className="row"><div className="col-xs-12">
            <Flyout label="Maturity date" className="btn-label btn-flyout medium-header" html={Labels.Maturity} />
        </div></div>
        <div className={"row form-group" + (errors.holdMaturity ? ' has-error': '')}
            style={{ ...(errors.holdMaturity && {marginBottom:'0px'}) }}>
            <div className="col-xs-6 col-md-4">
                <Field
                    data-name="advanced-screener-maturity-date-min"
                    name="holdMaturityMin"
                    component={Fields.Maturity}
                    error={errors.holdMaturity}
                    label="Minimum"
                />
            </div>
            <div className="col-xs-6 col-md-4">
                <Field
                    data-name="advanced-screener-maturity-date-max"
                    name="holdMaturityMax"
                    component={Fields.Maturity}
                    error={errors.holdMaturity}
                    label="Maximum"
                />
            </div>
        </div>
        {errors.holdMaturity && (
            <div className="row"><div className="col-xs-12 col-md-8">
            <label className="field-status has-error">{errors.holdMaturity}</label>
            </div></div>
        )}
    </div>
    <div className="col-xs-12 col-md-6">
        { hasRating &&
        <div className="row vertical-offset-md-sm"><div className="col-xs-12">
            <Flyout label="Credit rating" className="btn-label btn-flyout medium-header" html={Labels.Rating} />

            <div className="row vertical-offset-xxs">
            <div className="col-xs-12 col-md-12">
                <Field
                    data-name="advanced-screener-credit-rating-investment-grade"
                    name="rating"
                    component={Fields.Radio}
                    value="investment-grade"
                    label="Investment Grade"
                    className="radio-inline"
                    onClick={() => {
                        Object.assign(values, {
                            holdSpRatingMin:'BBB-',
                            holdSpRatingMax:'AAA',
                            holdMoodyRatingMin:'Baa3',
                            holdMoodyRatingMax:'Aaa'
                        })
                    }}
                />
                &nbsp;
                &nbsp;
                <Field
                    data-name="advanced-screener-credit-rating-high-yield"
                    name="rating" component={Fields.Radio}
                    value="high-yield"
                    label="High Yield"
                    className="radio-inline"
                    onClick={() => {
                        Object.assign(values, {
                            holdSpRatingMin:'C',
                            holdSpRatingMax:'BB+',
                            holdMoodyRatingMin:'C',
                            holdMoodyRatingMax:'Ba1'
                        })
                    }}
                />
                &nbsp;
                &nbsp;
                <Field
                    data-name="advanced-screener-credit-rating-all-ratings"
                    name="rating" component={Fields.Radio}
                    value="all-ratings"
                    label="All ratings"
                    className="radio-inline"
                    onClick={() => {
                        Object.assign(values, {
                            holdSpRatingMin:'ALL',
                            holdSpRatingMax:'ALL',
                            holdMoodyRatingMin:'ALL',
                            holdMoodyRatingMax:'ALL'
                        })
                    }}
                />
            </div>
            </div>

            <div className="row">
                <div className="col-xs-12 col-md-8 col-lg-6">
                    <label>Moody's credit rating</label>
                    <div className={"row form-group" + (errors.holdMoodyRating ? ' has-error': '')} style={{ ...(errors.holdMoodyRating && {marginBottom:'0px'}) }}>
                    <div className="col-xs-6 col-md-6 col-lg-6">
                        <Field
                            dataName="advanced-screener-moodys-credit-rating-min"
                            name="holdMoodyRatingMin"
                            component={Fields.Rating}
                            ratingType='moodys'
                            error={errors.holdMoodyRating}
                            label="Minimum Moody's credit rating"
                            labelClass="screen-reader-only"
                        />
                    </div>
                    <div className="col-xs-6 col-md-6 col-lg-6">
                        <Field
                            dataName="advanced-screener-moodys-credit-rating-max"
                            name="holdMoodyRatingMax"
                            component={Fields.Rating}
                            ratingType='moodys'
                            error={errors.holdMoodyRating}
                            label="Maximum Moody's credit rating"
                            labelClass="screen-reader-only"
                        />
                    </div>
                    </div>
                    {errors.holdMoodyRating && (
                        <div className="row"><div className="col-xs-12 col-md-12">
                        <label className="field-status has-error">{errors.holdMoodyRating}</label>
                        </div></div>
                    )}
                </div>

                <div className="col-xs-12 col-md-8 col-lg-6">
                    <label>S&amp;P credit rating</label>
                    <div className={"row form-group" + (errors.holdSpRating ? ' has-error': '')} style={{ ...(errors.holdSpRating && {marginBottom:'0px'}) }}>
                    <div className="col-xs-6 col-md-6 col-lg-6" >
                    <Field
                        dataName="advanced-screener-sp-credit-rating-min"
                        name="holdSpRatingMin"
                        component={Fields.Rating}
                        ratingType='sp'
                        error={errors.holdSpRating}
                        label="Minimum S&amp;P's credit rating"
                        labelClass="screen-reader-only"
                    />
                    </div>
                    <div className="col-xs-6 col-md-6 col-lg-6">
                    <Field
                        dataName="advanced-screener-sp-credit-rating-max"
                        name="holdSpRatingMax"
                        component={Fields.Rating}
                        ratingType='sp'
                        error={errors.holdSpRating}
                        label="Maximum S&amp;P's credit rating"
                        labelClass="screen-reader-only"
                    />
                    </div>
                    </div>
                    {errors.holdSpRating && (
                        <div className="row"><div className="col-xs-12 col-md-12">
                        <label className="field-status has-error">{errors.holdSpRating}</label>
                        </div></div>
                    )}
                </div>
            </div>

            <div className="row">
            <div className="col-xs-12 col-md-12">
            <Field
                data-name="advanced-screener-credit-ratings-and-or"
                name="holdRatingAndOr"
                component={Fields.Checkbox}
                label="Results can match Moody's or S&amp;P ratings selection"
            />
            </div>
            </div>
        </div></div>
        }
    </div>
    </div>

    <hr aria-hidden="true" className="vertical-offset-xs"></hr>

    <div className="row vertical-offset-md-xxs vertical-offset-sm-sm vertical-offset-xs-sm">
    <div className="col-xs-12 col-md-6">
        <div className="row"><div className="col-xs-12">
            <Flyout label="Price" className="btn-label btn-flyout medium-header" html={Labels.Price} />
        </div></div>
        <div className={"row form-group" + (errors.clientPrice ? ' has-error': '')} style={{ ...(errors.clientPrice && {marginBottom:'0px'}) }}>
            <div className="col-xs-6 col-md-4">
                <Field
                    data-name="advanced-screener-price-min"
                    name="clientPriceMin"
                    component={Fields.Price}
                    prefix="$"
                    error={errors.clientPrice}
                    label="Minimum"
                />
            </div>
            <div className="col-xs-6 col-md-4">
                <Field
                    data-name="advanced-screener-price-max"
                    name="clientPriceMax"
                    component={Fields.Price}
                    prefix="$"
                    error={errors.clientPrice}
                    label="Maximum"
                />
            </div>
        </div>
        {errors.clientPrice && (
            <div className="row"><div className="col-xs-12 col-md-8">
            <label className="field-status has-error">{errors.clientPrice}</label>
            </div></div>
        )}
    </div>
    <div className="col-xs-12 col-md-6">
        <div className="row"><div className="col-xs-12">
            <Flyout label="Quantity" className="btn-label btn-flyout medium-header" html={Labels.Quantity} />
        </div></div>
        <div className={"row form-group" + (errors.quantity ? ' has-error': '')} style={{ ...(errors.quantity && {marginBottom:'0px'}) }}>
            <div className="col-xs-6 col-md-4">
                <Field
                    data-name="advanced-screener-quantity-min"
                    name="quantityMin"
                    component={Fields.Quantity}
                    prefix="$"
                    suffix=",000"
                    error={errors.quantity}
                    label="Minimum"
                />
            </div>
            <div className="col-xs-6 col-md-4">
                <Field
                    data-name="advanced-screener-quantity-max"
                    name="quantityMax"
                    component={Fields.Quantity}
                    prefix="$"
                    suffix=",000"
                    error={errors.quantity}
                    label="Maximum"
                />
            </div>
        </div>
        {errors.quantity && (
            <div className="row"><div className="col-xs-12 col-md-8">
            <label className="field-status has-error">{errors.quantity}</label>
            </div></div>
        )}
    </div>
    </div>

    <hr aria-hidden="true" className="vertical-offset-xs"></hr>

    <div className="row vertical-offset-md-xxs vertical-offset-sm-sm vertical-offset-xs-sm">
    <div className="col-xs-12 col-md-6">
        <div className="row"><div className="col-xs-12">
            <Flyout label="Yield to worst" className="btn-label btn-flyout medium-header" html={Labels.Yield} />
        </div></div>
        <div className={"row form-group" + (errors.offerYtw ? ' has-error': '')} style={{ ...(errors.offerYtw && {marginBottom:'0px'}) }}>
            <div className="col-xs-6 col-md-4">
                <Field
                    data-name="advanced-screener-yield-to-worst-min"
                    name="offerYtwMin"
                    component={Fields.Yield}
                    suffix="%"
                    error={errors.offerYtw}
                    label="Minimum"
                />
            </div>
            <div className="col-xs-6 col-md-4">
                <Field
                    data-name="advanced-screener-yield-to-worst-max"
                    name="offerYtwMax"
                    component={Fields.Yield}
                    suffix="%"
                    error={errors.offerYtw}
                    label="Maximum"
                />
            </div>
        </div>
        {errors.offerYtw && (
            <div className="row"><div className="col-xs-12 col-md-8">
            <label className="field-status has-error">{errors.offerYtw}</label>
            </div></div>
        )}

    </div>
    <div className="col-xs-12 col-md-6">
        <div className="row"><div className="col-xs-12">
            <Flyout label="Yield to maturity" className="btn-label btn-flyout medium-header" html={Labels.YieldToMaturity} />
        </div></div>
        <div className={"row form-group" + (errors.offerYtm ? ' has-error': '')} style={{ ...(errors.offerYtm && {marginBottom:'0px'}) }}>
            <div className="col-xs-6 col-md-4">
                <Field
                    data-name="advanced-screener-yield-to-maturity-min"
                    name="offerYtmMin"
                    component={Fields.Yield}
                    suffix="%"
                    error={errors.offerYtm}
                    label="Minimum"
                />
            </div>
            <div className="col-xs-6 col-md-4">
                <Field
                    data-name="advanced-screener-yield-to-maturity-max"
                    name="offerYtmMax"
                    component={Fields.Yield}
                    suffix="%"
                    error={errors.offerYtm}
                    label="Maximum"
                />
            </div>
        </div>
        {errors.offerYtm && (
            <div className="row"><div className="col-xs-12 col-md-8">
            <label className="field-status has-error">{errors.offerYtm}</label>
            </div></div>
        )}
    </div>
    </div>

    <hr aria-hidden="true" className="vertical-offset-xs"></hr>

    <div className="row vertical-offset-md-xxs vertical-offset-sm-sm vertical-offset-xs-sm">
    <div className="col-xs-12 col-md-12">
        <div className="row"><div className="col-md-12 col-xs-12">
            <Flyout label="Coupon" className="btn-label btn-flyout medium-header" html={Labels.Coupon} />
        </div></div>
        <div className="row">
            <div className="col-xs-12 col-md-4">
                <div className={"row form-group" + (errors.holdCoupon ? ' has-error': '')}  style={{ ...(errors.holdCoupon && {marginBottom:'0px'}) }}>
                <div className="col-xs-6 col-md-6">
                    <Field
                        data-name="advanced-screener-coupon-min"
                        name="holdCouponMin"
                        component={Fields.Yield}
                        suffix="%"
                        error={errors.holdCoupon}
                        label="Minimum"
                    />
                </div>
                <div className="col-xs-6 col-md-6">
                    <Field
                        data-name="advanced-screener-coupon-max"
                        name="holdCouponMax"
                        component={Fields.Yield}
                        suffix="%"
                        error={errors.holdCoupon}
                        label="Maximum"
                    />
                </div>
                </div>
                {errors.holdCoupon && (
                    <div className="row"><div className="col-xs-12 col-md-12">
                    <label className="field-status has-error">{errors.holdCoupon}</label>
                    </div></div>
                )}
            </div>
            <div className="col-xs-12 col-md-8">
                <div className="row form-group" style={{marginBottom:'0px'}}>

                <div className="col-md-4 col-xs-12">
                    <FieldArray
                        name="couponFrequencies"
                        render={(args) => <Fields.SelectMulti {...args}
                            dataName="advanced-screener-coupon-frequency"
                            options={FormFieldArrays.couponFrequencies}
                            label={<Flyout label="Coupon frequency" html={Fields.Labels.CouponFrequencies} />}
                        />}
                    />
                </div>
                <div className="col-md-4 col-xs-12">
                    <FieldArray
                        name="couponPayMonths"
                        render={(args) => <Fields.SelectMulti {...args}
                            dataName="advanced-screener-coupon-pay-month"
                            options={FormFieldArrays.couponPayMonths}
                            label={<Flyout label="Coupon pay month" html={Fields.Labels.CouponPayMonths} />}
                        />}
                    />
                </div>
                <div className="col-md-4 col-xs-12">
                    <FieldArray
                        name="couponFeatures"
                        render={(args) => <Fields.SelectMulti {...args}
                            dataName="advanced-screener-coupon-features"
                            options={FormFieldArrays.couponFeatures}
                            listConfig={{ style: { minWidth:'200px' } }}
                            label={<Flyout label="Coupon features" html={Fields.Labels.CouponFeatures} />}
                        />}
                    />
                </div>

                </div>
            </div>
        </div>
    </div>
    </div>

    <hr aria-hidden="true" className="vertical-offset-xs"></hr>

    <div className="row vertical-offset-md-xxs vertical-offset-sm-sm vertical-offset-xs-sm">
    <div className="col-xs-12 col-md-12">
        <div className="row"><div className="col-xs-12">
            <h3 className="medium-header">Redemption Features &amp; Special Provisions</h3>
        </div></div>
        <div className="row form-group" style={{marginBottom:'0px'}}>
            <div className="col-md-3 col-xs-12">
                <FieldArray
                    name="callFeatures"
                    render={(args) => <Fields.SelectMulti {...args}
                        dataName="advanced-screener-call-features"
                        options={FormFieldArrays.callFeatures}
                        label={<Flyout label="Call features" html={Fields.Labels.CallFeatures} />}
                    />}
                />
            </div>
            <div className="col-md-3 col-xs-12">
                <FieldArray
                    name="putFeatures"
                    render={(args) => <Fields.SelectMulti {...args}
                        dataName="advanced-screener-put-features"
                        options={FormFieldArrays.putFeatures}
                        label={<Flyout label="Put features" html={Fields.Labels.PutFeatures} />}
                    />}
                />
            </div>
            <div className="col-md-3 col-xs-12">
                <FieldArray
                    name="otherFeatures"
                    render={(args) => <Fields.SelectMulti {...args}
                        dataName="advanced-screener-other-features"
                        options={FormFieldArrays.otherFeatures}
                        listConfig={{ style: { minWidth:'300px' } }}
                        label={<Flyout label="Other features" html={Fields.Labels.OtherFeatures} />}
                    />}
                />
            </div>
            <div className="col-xs-12 col-md-6">
                <div className={"row form-group" + (errors.holdFirstCall ? ' has-error': '')}
                    style={{ ...(errors.holdFirstCall && {marginBottom:'0px'}) }}>
                    <div className="col-xs-6 col-md-4">
                        <Field
                            data-name="advanced-screener-next-call-date-min"
                            name="holdFirstCallMin"
                            component={Fields.Maturity}
                            error={errors.holdFirstCall}
                            label={<Flyout label="Next call min" html={Labels.NextCall} />}
                            labelStyle={{whiteSpace:'nowrap'}}
                            />
                    </div>
                    <div className="col-xs-6 col-md-4">
                        <Field
                            data-name="advanced-screener-next-call-date-max"
                            name="holdFirstCallMax"
                            component={Fields.Maturity}
                            error={errors.holdFirstCall}
                            label={<Flyout label="Next call max" html={Labels.NextCall} />}
                            labelStyle={{whiteSpace:'nowrap'}}
                            />
                    </div>
                </div>
                {errors.holdFirstCall && (
                    <div className="row"><div className="col-xs-12 col-md-8">
                    <label className="field-status has-error">{errors.holdFirstCall}</label>
                    </div></div>
                )}
            </div>
        </div>
    </div>
    </div>

    <hr aria-hidden="true" className="vertical-offset-xs"></hr>

    <div className="row vertical-offset-md-xxs vertical-offset-sm-sm vertical-offset-xs-sm">
    <div className="col-xs-12 col-md-12">
    <div className="row form-group">
            <div className="col-md-3 col-xs-12">
                <Field
                    dataName="advanced-screener-offering-posted"
                    name="offeringPosted"
                    component={Fields.Select}
                    options={['Any time', 'New today']}
                    label="Offering posted"
                />
            </div>
            <div className="col-md-3 col-xs-12">
                <Field
                    dataName="advanced-screener-sort-by"
                    name="sortBy"
                    component={Fields.Select}
                    options={SORT_BY}
                    label="Sort by"
                />
            </div>
            <div className="col-md-3 col-xs-12">
                <Field
                    dataName="advanced-screener-sort-order"
                    name="sortOrder"
                    component={Fields.Select}
                    options={['Ascending', 'Descending']}
                    label="Sort order"
                />
            </div>
            <div className="col-md-2 col-xs-12">
                <Field
                    dataName="advanced-screener-results-per-page"
                    name="resultsPerPage"
                    component={Fields.Select}
                    options={[5, 10, 20, 50, 100, 200, 300]}
                    label="Results per page"
                    labelStyle={{whiteSpace:'nowrap'}}
                />
            </div>
        </div>
    </div>
    </div>



    <div className="row vertical-offset-md-xxs vertical-offset-sm-sm vertical-offset-xs-sm">
    <div className="col-xs-12 col-md-4">
        <button
            data-name="advanced-screener-clear-all-button"
            className="btn btn-lg btn-primary-outline btn-block"
            type="button"
            onClick={() => {
                resetForm(getResetValues(values))
                setTimeout(() => { validateForm() })
            }}
        >Clear all </button>
    </div>
    <div className="col-xs-12 col-md-4">
        <SaveSearchButton errors={errors} values={values} />
    </div>
    <div className="col-xs-12 col-md-4">
        <SubmitButton errors={errors} values={values} />
    </div>
    </div>
    </form>)
}

const SORT_BY = [
    {label:'Quantity', value:'askQuantity'},
    {label:'Issuer', value:'holdIssue'},
    {label:'Coupon', value:'holdCoupon'},
    {label:'Maturity', value:'holdMaturitySortDt'},
    {label:'Price', value:'askPrice'},
    {label:'Yield to worst', value:'askYield'},
    {label:'Yield to maturity', value:'askYieldmat'}
]


// WEBPACK FOOTER //
// ./src/advanced-screener/search-form/form.js